<template>
	<component 
		:is="name + 'Icon'"
		class="icon material-icons pointer-events-none"
		:style="{
			width: size + 'px',
			height: size + 'px',
			fontSize: size + 'px'
		}"
	>{{ name }}</component>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close'
import MenuIcon from 'vue-material-design-icons/Menu'
import MagnifyIcon from 'vue-material-design-icons/Magnify'
import ArrowLeftIcon from 'vue-material-design-icons/ArrowLeft'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown'

export default {
	name: 'UiIcon',
	components: {
		CloseIcon,
		MenuIcon,
		MagnifyIcon,
		ArrowLeftIcon,
		ChevronUpIcon,
		ChevronDownIcon,
	},
	props: {
		name: {
			type: String,
			required: true
		},
		size: {
			type: Number,
			default: 24
		}
	}
}
</script>